let _ = require("ES/lib/lodash");
let dd = require("ES/lib/dd");
let radio = require("ES/lib/radio");
let esUtils = require("ES/utils/esUtils");
let DateRange = require("ES/widgets/DateRange");
let esStatusImage = require("./esStatusImage");

module.exports = dd.createClass({
	__onClick: esUtils.wrapPreventDefault(function(){
		let result = this.props.result || {};
		radio("Hashbang_set").broadcast("/events/" + result.eid);
	}),
	render(){
		let {my_speaker_names_by_sid, result} = this.props;
		result = result || {};

		let loc = (result.venue_city ? result.venue_city + ", " : "") + (result.venue_st ? result.venue_st + " " : "") + (result.venue_country || "");

		return dd.div({className: "SearchResult clickable", onClick: this.__onClick},
			dd.div({className: "pull-left", style: {marginRight: 10, marginBottom: "1em"}},
				esStatusImage({
					"status": result["status"],
					delivery_method: result.deliverymethod,
					has_parent: result.parentID > 0,
					has_children: result.n_child_events > 0
				})
			),
			dd.div({style: {float: "right", marginLeft: 10, textAlign: "right"}},
				result.mp_payment_total > 0 ? esUtils.format_currency(result.mp_payment_total, 0) : null,
				" ",
				result.mp_unread_messages > 0 ? dd.span(null,
					dd.i({className: "fa fa-envelope-o"}),
					" " + result.mp_unread_messages
				) : null
			),
			dd.h4(null,
				result.organization,
				dd.span({className: "text-muted", style: {marginLeft: ".5em"}}, result.meetingname)
			),
			dd.div({className: "stagetime"},
				DateRange({start: result.stagetime_starttime, stop: result.stagetime_stoptime}),
				esUtils.isBlank(loc) ? null : dd.span({className: "location text-muted"},
					dd.i({className: "fa fa-map-marker"}), " " + loc
				)
			),
			dd.div({className: "clearfix"}),
			_.size(my_speaker_names_by_sid) > 0 ? dd.div({className: "text-muted text-right"},
				_.map(result.sids, function(sid){
					return my_speaker_names_by_sid[sid];
				}).join(", ")
			) : null
		);
	}
});



// WEBPACK FOOTER //
// ./src/components/main_view/calendar_area/SearchResult.js